import { MapPin, Phone } from 'lucide-react';

export function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="max-w-2xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <img src="/logo.png" alt="Payal Garg" className="h-10 w-auto object-contain brightness-0 invert opacity-50" />
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-[11px]">
          <div className="flex items-start gap-1.5">
            <MapPin className="w-3 h-3 mt-0.5 text-[#636366] shrink-0" strokeWidth={1.5} />
            <span>SCO 324-325, Sector 38-D, Chandigarh</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Phone className="w-3 h-3 text-[#636366] shrink-0" strokeWidth={1.5} />
            <a href="tel:09876794211">098767 94211</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
